'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function FooterMethods() {
  const { t } = useTranslations();

  const data = [
    {
      id: 'payments',
      name: t('text3460'),
      images: [
        {
          src: '/images/methods/payments/gopay.png',
          name: 'GoPay',
        },
        {
          src: '/images/methods/payments/paypal.png',
          name: 'PayPal',
        },
        {
          src: '/images/methods/payments/googlepay.png',
          name: 'Google Pay',
        },
        {
          src: '/images/methods/payments/applepay.png',
          name: 'Apple Pay',
        },
      ],
    },
    {
      id: 'delivery',
      name: t('text3461'),
      images: [
        {
          src: '/images/methods/delivery/packeta.png',
          name: 'Packeta',
        },
        {
          src: '/images/methods/delivery/dpd.png',
          name: 'DPD',
        },
        {
          src: '/images/methods/delivery/sps.png',
          name: 'SPS',
        },
      ],
    },
  ];

  return (
    <div
      className={cn(
        'custom-container',
        'grid grid-cols-1 gap-8 sm:grid-cols-2 md:gap-12 lg:gap-16',
      )}
    >
      {data
        .filter(method => method.name.trim().length > 0)
        .map(method => (
          <div
            key={method.id}
            className="col-span-1 flex w-full items-center justify-start gap-2.5"
          >
            <p className="tracking-tight text-white/70">{method.name}:</p>
            {method.images.map(image => (
              <Image
                key={image.name}
                src={image?.src}
                alt={image?.name}
                width={0}
                height={0}
                className="h-8 w-auto object-contain object-center"
                sizes="100vw"
              />
            ))}
          </div>
        ))}
    </div>
  );
}
